<template>
	<div class="container">
		<el-row style="height: 100%;position: relative;">
			<el-col :span="10" style="height: 100%;position: relative;">
				<div class="full">
					<div class="left_container full">
						<div class="title flex">部门列表</div>
						<div class="list" style="border-bottom: 1px solid #d7dae2;height: 360px;">
							<department-tree ref="departmentTree" @select="departmentTreeChange" />
						</div>
						<div class="title flex">相对位置</div>
						<div class="list" style="height: 150px;">
							<div class="full" style="box-sizing: border-box;padding: 5px;" @click="clearRelativep">
								<div @click="relativepItemClick(item,index,$event)" @dblclick="toRight" class="relativep"
									:class="{relativep_active:item.active}" v-for="(item,index) in relativeP"
									:key="index">{{item.label}}</div>
							</div>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :span="4" style="height: 100%;position: relative;">
				<div class="middle flex">
					<div>
						<el-button style="width: 50px;height: 50px;" type="primary" icon="el-icon-arrow-right" circle
							@click="toRight"></el-button>
					</div>
					<div style="margin-top: 50px;">
						<el-button style="width: 50px;height: 50px;" type="primary" icon="el-icon-arrow-left" circle
							@click="toLeft"></el-button>
					</div>
				</div>
			</el-col>
			<el-col :span="10" style="height: 100%;position: relative;">
				<div class="full">
					<div class="right_container full">
						<div class="title flex">
							<div>授权列表</div>
							<el-button icon="el-icon-refresh-left" style="margin-left: 10px;" circle size="mini"
								@click="flashAuthList"></el-button>
						</div>
						<div class="list" style="height: 550px;">
							<div class="full" style="box-sizing: border-box;padding: 5px;" @click="clearDataItem">
								<div @click="dataItemClick(item,index,$event)" @dblclick="toLeft" class="data"
									:class="{data_active:item.active}" v-for="(item,index) in data" :key="index">
									{{item.departmentname+'（'+item.typename+'）'}}</div>
							</div>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>

</template>
<style scoped>
	.container {
		position: relative;
		width: 100%;
		height: 600px;
	}

	.middle {
		height: 100%;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.left_container {
		box-sizing: border-box;
		border: 1px solid #d7dae2;
	}

	.right_container {
		box-sizing: border-box;
		border: 1px solid #d7dae2;
	}

	.title {
		position: relative;
		width: 100%;
		height: 40px;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		font-size: 18px;

		background: rgb(244, 244, 245);
		border-bottom: 1px solid #d7dae2;
	}

	.list {
		position: relative;
		width: 100%;
		height: 410px;
		overflow: auto;
	}

	.relativep {
		cursor: pointer;
		user-select: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-o-user-select: none;
		-ms-user-select: none;
		-webkit-touch-callout: none;
		font-size: 14px;
		box-sizing: border-box;
		padding: 0px 4px;
	}

	.relativep_active {
		background-color: #409EFF;
		color: white;
	}

	.data {
		cursor: pointer;
		user-select: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-o-user-select: none;
		-ms-user-select: none;
		-webkit-touch-callout: none;
		font-size: 14px;
	}

	.data_active {
		background-color: #409EFF;
		color: white;
	}
</style>
<script>
	import departmentTree from '@_system/components/formcomponents/common/select/department/tree.vue'
	export default {
		props: {
			id: {
				type: [Number, String],
				default: () => {
					return 0
				}
			}
		},
		data() {
			return {
				currentdepartment: null,
				relativeP: [{
						label: '当前部门所有人',
						type: 'self',
						active: false
					},
					{
						label: '当前部门管理员',
						type: 'self_manager',
						active: false
					},
					{
						label: '下级部门所有人',
						type: 'children_only',
						active: false
					},
					{
						label: '下级部门管理员',
						type: 'children_manager_only',
						active: false
					},
					{
						label: '上级部门所有人',
						type: 'parent_only',
						active: false
					},
					{
						label: '上级部门管理员',
						type: 'parent_manager_only',
						active: false
					},
					{
						label: '及其下级部门所有人',
						type: 'children',
						active: false
					},
					{
						label: '及其下级部门管理员',
						type: 'children_manager',
						active: false
					},
					{
						label: '及其上级部门所有人',
						type: 'parent',
						active: false
					},
					{
						label: '及其上级部门管理员',
						type: 'parent_manager',
						active: false
					},
				],
				data: []

			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			departmentTreeChange(e) {
				this.currentdepartment = e
				//this.clearrelativep()
			},
			relativepItemClick(item, index, e) {
				e.stopPropagation()
				this.clearRelativep()
				this.relativeP[index].active = true
			},
			clearRelativep() {
				this.relativeP.forEach((item) => {
					item.active = false
				})
			},
			getActiveRelativep() {
				let obj = null
				this.relativeP.forEach((item) => {
					if (item.active) {
						obj = item
					}
				})
				return obj
			},
			dataItemClick(item, index, e) {
				e.stopPropagation()
				this.clearDataItem()
				this.data[index].active = true
			},
			clearDataItem() {
				this.data.forEach((item) => {
					item.active = false
				})
			},
			getActiveDataItem() {
				let obj = null
				this.data.forEach((item, index) => {
					if (item.active) {
						obj = {
							item: item,
							index: index
						}
					}
				})
				return obj
			},
			checkDataItemUnique(checkItem) {
				let obj = null
				this.data.forEach((item) => {
					if (item.departmentid == checkItem.departmentid && item.type == checkItem.type) {
						obj = true
					}
				})
				return obj
			},
			toRight() {
				let relativep = this.getActiveRelativep()
				if (!this.currentdepartment) {
					this.$message.error({
						message: '请选择部门',
					})
				} else if (!relativep) {
					this.$message.error({
						message: '请选择相对位置',
					})
				} else {
					let obj = {
						departmentid: this.currentdepartment.id,
						departmentname: this.currentdepartment.name,
						typename: relativep.label,
						type: relativep.type,
						active: false,
					}
					if (!this.checkDataItemUnique(obj)) {
						this.data.push(obj)
						this.dataChange()
					} else {
						this.$message.error({
							message: '该选项已存在',
						})
					}

					//console.log(this.currentdepartment,relativep)
				}
			},
			toLeft() {
				let obj = this.getActiveDataItem()
				if (obj) {
					this.data.splice(obj.index, 1)
					this.dataChange()
				}
			},
			submitData() {
				return this.data
			},
			setData(data) {
				data.forEach((item) => {
					item.active = false
				})
				this.data = data
			},
			dataChange() {
				this.$emit('datachange', {
					data: this.data,
					type: 'department'
				})
			},
			flashAuthList() {
				console.log(this.data)
				console.log(this.$refs.departmentTree.departmentsource)
				let sourceDepartment = this.$refs.departmentTree.departmentsource

				let data = []
				this.data.forEach((item) => {
					let index = sourceDepartment.findIndex((_item) => {
						return _item.id == item.departmentid
					})
					if (index !== -1) {
						item.departmentname = sourceDepartment[index].name
						data.push(item)
					}
				})
				console.log(data)
				this.data = data
			}
		},
		components: {
			departmentTree
		}
	}
</script>
